import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";

/**
 * sets opportunity of the selected attacker
 * @param {string} id - uuid of the attacker
 * @param {string} opportunity - string value of available opportunity
 *
 */
export const setAttackerOpportunity = ({ id, opportunity }) => {
  return Brm.attackerApi.setAttackerAvailableOpportunity(id, { body: opportunity });
};

/**
 * Custom hook to change the opportunity of a existing Attacker
 * @param {object} config hook configuration
 * @returns react-query ReactQuery.useMutation
 */
export const useSetAttackerOpportunity = ({ config = {} }) => {
  return ReactQuery.useMutation({
    ...config,
    mutationFn: setAttackerOpportunity,
  });
};
